import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import language from "../../language";
import icons from "../../constants/icons";
import { fetchIndustries } from "../../queries/industries/industriesQuery.js";
import { Button } from "../Button";
import { getStorage, setStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchBusinessCategories } from "../../queries/business/businessCategoriesQuery";
import { fetchBusinessProfile } from "../../queries/profile/merchantProfile";
import { Loading } from "../Loader";
import { listenOnSaveBusinessProfile } from "../../actions/BusinessProfile.js";
import { saveProfileUnits } from "../../actions/ProfileUnits.js";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../utils/api.js";

class GeneralInfo extends React.Component {
  state = {
    legalName: "",
    error: {},
    isSubmitting: false,
    registrationDate: "",
    registrationNumber: "",
    isLoading: false,
    id: "",
    user: {},
    taxIdentificationNumber: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();

    await this.setState({ user, legalName: user?.tenant?.name || "" });

    await this.getBusinessProfile(true);

    this.getIndustries(true);
  };

  updateState(data) {
    if (data && Object.keys(data).length > 0) {
      this.setState({
        legalName: data.name,
        registrationDate: moment(data.registrationDate).format("YYYY-MM-DD"),
        registrationNumber: data.registrationNumber,
        taxIdentificationNumber: data.taxIdentificationNumber,
        id: data.id || "",
        industry: data.industryId
          ? {
              label: data.industryName,
              value: data.industryId,
            }
          : null,
      });

      //update profile unit session storage
      this.handleUpdateProfileUnitsStorage("BUSINESS_PROFILE");
    }
  }

  handleUpdateProfileUnitsStorage = async (unit) => {
    const { profileUnits } = this.props;

    const modifiedUnits = profileUnits?.map((el) => {
      if (el.unit === unit && !el.provided) {
        el.provided = true;
      }

      return el;
    });

    await this.props.dispatch(saveProfileUnits(modifiedUnits));
  };

  getBusinessProfile = async (isLoading) => {
    const { defaultLanguage } = this.props;
    const user = await getStorage();

    try {
      this.setState({ isLoading });

      const data = await fetchBusinessProfile(defaultLanguage);

      this.setState({
        isLoading: false,
      });

      if (!data) return;

      const profileInfo = data.length > 0 ? data[0] : {};

      this.updateState(profileInfo);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getIndustries = async (isLoadingIndustries) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingIndustries });

      const data = await fetchIndustries(defaultLanguage, {
        listType: "dropdown",
      });

      this.setState({
        isLoadingIndustries: false,
        industries: data,
      });
    } catch (error) {
      this.setState({ isLoadingIndustries: false });
    }
  };

  getBusinessCategories = async (isLoadingCategories) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCategories });

      const data = await fetchBusinessCategories(defaultLanguage, {
        listType: "dropdown",
      });

      this.setState({
        isLoadingCategories: false,
        businessCategories: data,
      });
    } catch (error) {
      this.setState({ isLoadingCategories: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState(
      {
        [field]: e.target ? e.target.value : e,
        error,
      },
      () => {
        if (field === "businessCategory" || field === "country") {
        }
      }
    );
  }

  validateForm() {
    let {
      error,
      legalName,
      registrationDate,
      registrationNumber,
      industry,
      user,
      taxIdentificationNumber,
    } = this.state;

    if (legalName === "") {
      error.legalName =
        language[this.props.defaultLanguage].legal_name_required;
    }

    if (registrationDate === "") {
      error.registrationDate =
        language[this.props.defaultLanguage].registration_date_required;
    }

    if (registrationNumber === "") {
      error.registrationNumber =
        language[this.props.defaultLanguage].registration_number_required;
    }

    if (taxIdentificationNumber === "") {
      error.taxIdentificationNumber =
        language[this.props.defaultLanguage].tax_identification_number_required;
    }

    if (!industry) {
      error.industry = language[this.props.defaultLanguage].industry_required;
    }

    if (!user.businessCategory) {
      alert(language[this.props.defaultLanguage].business_category_required);
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let {
      error,
      legalName,
      registrationDate,
      registrationNumber,
      industry,
      id,
      user,
      taxIdentificationNumber,
    } = this.state;

    if (Object.keys(error).length === 0) {
      this.setState({ isSubmitting: true });

      const requestBody = {
        name: legalName,
        registrationDate,
        registrationNumber,
        industryId: industry.value,
        businessCategoryId: user.businessCategoryId,
        businessProfileId: id || "",
        countryId: user.countryId,
        taxIdentificationNumber,
      };

      let method = "POST";

      const options = {
        method,
        url: `${api("profile")}/business`,
        data: requestBody,
        headers: {
          Authorization: "Bearer " + user.accessToken,
          Accept: "application/json",
        },
      };

      axios(options)
        .then((data) => {
          this.setState({ isSubmitting: false });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "update_business_profile_success"
                : "add_business_profile_success"
            ]
          );

          if (this.props.handleCollapsePreviousAndShowNext) {
            this.props.handleCollapsePreviousAndShowNext();
          }

          this.getBusinessProfile(true);

          this.props.dispatch(listenOnSaveBusinessProfile(true));

          this.props.profileUpdated(true);

          this.updateLocalProfileStorage();
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isSubmitting: false });
          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "unable_to_update_business_profile"
                : "unable_to_add_business_profile"
            ]
          );
        });
    }
  };

  updateLocalProfileStorage = async () => {
    let { legalName, taxIdentificationNumber, user } = this.state;
    //save legal name to the local storage
    user["businessLegalName"] = legalName;
    user["taxIdentificationNumber"] = taxIdentificationNumber;

    await setStorage(user);
  };
  renderForm() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Input
            label={language[this.props.defaultLanguage].legal_name}
            placeholder={
              language[this.props.defaultLanguage].legal_name_placeholder
            }
            leftIcon={icons.user}
            error={this.state.error.legalName}
            onChange={(e) => this.onChangeInput("legalName", e)}
            value={this.state.legalName}
            required
            disabled
          />
        </div>
        <div className="col-md-6">
          <Input
            label={language[this.props.defaultLanguage].registration_number}
            placeholder={
              language[this.props.defaultLanguage]
                .registration_number_placeholder
            }
            leftIcon={icons.numbers}
            error={this.state.error.registrationNumber}
            onChange={(e) => this.onChangeInput("registrationNumber", e)}
            value={this.state.registrationNumber}
            required
            disabled={this.state.id !== "" && this.props.approved}
          />
        </div>
        <div className="col-md-6">
          <Input
            label={
              language[this.props.defaultLanguage].tax_identification_number
            }
            placeholder={
              language[this.props.defaultLanguage]
                .tax_identification_number_placeholder
            }
            leftIcon={icons.numbers}
            error={this.state.error.taxIdentificationNumber}
            onChange={(e) => this.onChangeInput("taxIdentificationNumber", e)}
            value={this.state.taxIdentificationNumber}
            required
            disabled={this.state.id !== "" && this.props.approved}
          />
        </div>
        <div className="col-md-6">
          <Input
            label={language[this.props.defaultLanguage].registration_date}
            placeholder={
              language[this.props.defaultLanguage].registration_date_placeholder
            }
            leftIcon={icons.calendar}
            error={this.state.error.registrationDate}
            onChange={(e) => this.onChangeInput("registrationDate", e)}
            type="date"
            value={this.state.registrationDate}
            required
            disabled={this.state.id !== "" && this.props.approved}
            max={moment().format("YYYY-MM-DD")}
          />
        </div>
        <div className="col-md-6">
          <Select
            options={this.state.industries}
            label={language[this.props.defaultLanguage].industry}
            placeholder={language[this.props.defaultLanguage].select}
            leftIcon={icons.industry}
            error={this.state.error.industry}
            onChange={(e) => this.onChangeInput("industry", e)}
            value={this.state.industry}
            isLoading={this.state.isLoadingIndustries}
            required
            disabled={this.state.id !== "" && this.props.approved}
          />
        </div>
        <div className="col-md-6">
          <Input
            label={language[this.props.defaultLanguage].business_category}
            leftIcon={icons.business}
            value={this.state?.user?.businessCategory}
            required
            disabled
          />
        </div>
        {this.state.user.countryName && (
          <div className="col-md-6">
            <Input
              label={language[this.props.defaultLanguage].country}
              leftIcon={icons.country}
              value={this.state?.user?.countryName}
              required
              disabled
            />
          </div>
        )}
        {!this.state.user.countryId && (
          <div className="col-md-12">
            <div className="alert alert-danger">
              <h3>Country is missing</h3>
              <p>
                Return to the{" "}
                <b>
                  <u>
                    <Link to="/merchant/kyc/onboarding/initial">
                      Business Category Page
                    </Link>
                  </u>
                </b>{" "}
                and provide the necessary information by specifying the country
                for your business.
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <>
        <div className="card-body">
          {this.state.isLoading ? (
            <Loading fullScreen />
          ) : (
            <>{this.renderForm()}</>
          )}
        </div>
        <div
          className={`modal-footer ${this.props.footerClassName}`}
          style={{ paddingBottom: "1rem" }}
        >
          {(!this.state.id || !this.props.approved) && (
            <Button
              text={language[this.props.defaultLanguage].submit}
              onPress={this.onSubmit.bind(this)}
              isSubmitting={this.state.isSubmitting}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { profileUnits } = state.ProfileUnits;
  return {
    defaultLanguage,
    profileUnits,
  };
};

export default connect(mapStateToProps)(GeneralInfo);
